import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Trans } from '@lingui/macro'
import { Button } from 'components/UI/Button/Button'
import { Loader } from 'components/UI/Loader/Loader'
import { IdOrdersState } from 'model/dashboardOrders/dOrdersReducer';
import { SelectBox, typeValuesListItem } from 'components/UI/SelectBox/SelectBox';
import { getStoreList, } from 'model/dashboardStores/dStoresAPI';
import { logoutSagaAC, } from 'model/system/systemActionCreators';
import { dOrdersSetSelectedStoreAC } from 'model/dashboardOrders/dOrdersActionCreators';


// Type
export type typePopupEdit = {
    variant?: string,
    setOpenPopup: React.Dispatch<React.SetStateAction<boolean>>
}

// Component
export const PopupSelectStore: React.FC<typePopupEdit> = ({ variant, setOpenPopup }) => {

    const dispatch = useDispatch()

    // System
    const selectedStore = useSelector((state: { dOrders: IdOrdersState }) => state.dOrders.selectedStore)
    const [ loader, setLoader ] = useState(true)


    // Did mount
    useEffect(() => {

        const setData = async () => {

            let responseStores = await getStoreList({ filters: { name: null, deleted: false }, full: false })


            if (responseStores.status === 200) {
                const newStoresList = [ ...selectStoreList, ...responseStores.data ]
                setSelectStoreList(newStoresList)
                setLoader(false)
            } else if (responseStores.status === 401) {
                setLoader(false)
                dispatch(logoutSagaAC())
            }
        }
        setData()

        // eslint-disable-next-line
    }, [])

    //value
    const [ storeIdValue, setStoreIdValue ] = useState<string | number | null>(selectedStore?.id || null)
    const [ selectStoreList, setSelectStoreList ] = useState<typeValuesListItem[]>([])


    // Validation
    const [ validationObj, setValidationObj ] = useState({
                                                             requiredStore: true,
                                                         })
    useEffect(() => {
        if (storeIdValue === null) {
            setValidationObj({ ...validationObj, ...{ requiredStore: false } })
        } else {
            setValidationObj({ ...validationObj, ...{ requiredStore: true } })
        }
        // eslint-disable-next-line
    }, [ storeIdValue ])

    const onSaveHandler = async (e: React.FormEvent) => {
        e.preventDefault()
        setLoader(true)
        const store = selectStoreList.find((item) => item.id === storeIdValue)

        // @ts-ignore
        await dispatch(dOrdersSetSelectedStoreAC(store))
        setLoader(false)
        setOpenPopup(false)

    }

    return (
        <>

            <form className="sm:w-80">


                <div className="grid gap-4 ">
                    <div>
                        { loader ? <Loader/> : <SelectBox
                            label={ <Trans>Store :</Trans> }
                            valuesList={ selectStoreList }
                            valueId={ storeIdValue }
                            setIdValue={ setStoreIdValue }
                            labelClassname="self-center"
                            selectBosClassname={ 'w-80' }
required={true}
                        /> }
                    </div>
                </div>

                <div className="flex gap-4 mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">

                    <Button type="submit"
                            variant={ variant }
                            disabled={ !( validationObj.requiredStore ) || loader }
                            label={ <Trans>Save</Trans> }
                            onClick={ (e) => onSaveHandler(e) }
                    />
                    <Button type="button"
                            variant={ variant }
                            secondary={ true }
                            label={ <Trans>Cancel</Trans> }
                            onClick={ () => setOpenPopup(false) }/>

                </div>

            </form>
        </>
    )
}
